import styled from '@emotion/styled';
import { ntaBodyCss } from '../typography';

const SCROLL_NAV_UP_SRC = '/nta-experience/scroll-nav-up.svg';
const SCROLL_NAV_DOWN_SRC = '/nta-experience/scroll-nav-down.svg';

const Hint = styled.p`
  margin: 0;
  display: inline;
  ${ntaBodyCss}
`;

const ArrowIcon = styled.img`
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 0 2px;
  vertical-align: middle;
`;

const NtaScrollArrowsHint = () => (
  <Hint>
    You can click on{' '}
    <ArrowIcon src={SCROLL_NAV_DOWN_SRC} width={20} height={20} alt="" /> to
    navigate to the bottom and{' '}
    <ArrowIcon src={SCROLL_NAV_UP_SRC} width={20} height={20} alt="" /> to
    navigate to the top of the question area without scrolling.
  </Hint>
);

export default NtaScrollArrowsHint;
